import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--circuit", {
  segmentWidth: units.px(10),
  offset: 0,
  pointX: 0,
  pointY: 0
});
const wrapper = "_35swy0rrle";
const circuit = "_35sccw6e0g";
const item = "_35simq6ah4";
function getPointOnCircle(t) {
  const deg = t * 360 - 90;
  const rad = deg * (Math.PI / 180);
  return {
    x: 0.5 + 0.5 * Math.cos(rad),
    y: 0.5 + 0.5 * Math.sin(rad)
  };
}

export { circuit, getPointOnCircle, item, tokens, wrapper };
import "./container.print.style.linaria.module.css";
//# sourceMappingURL=container.print.style.js.map
